import { withQuery } from './lib/withQuery'

export const getAudioCommentsUrl = (id: string) => withQuery('audio/comments', { id })

export const getProjectCommentsUrl = (id: string) => withQuery('project/comments', { id })

export const createAudioCommentUrl = (id: string) => withQuery('audio/comment', { id })

export const createProjectCommentUrl = (id: string) => withQuery('project/comment', { id })

export const deleteCommentUrl = (id: string) => withQuery('comment', { id })

export const updateCommentUrl = (id: string) => withQuery('comment', { id })

export const updateReplyUrl = (id: string) => withQuery('reply', { id })

export const createReplyCommentUrl = (commentId: string) =>
    withQuery('comment/reply', { id: commentId })
